// extracted by mini-css-extract-plugin
export var childrenContainer = "_d7-0";
export var virtualScrollArea = "_d7-1";